import Vue from "vue";
import Router from "vue-router";
import Study from "@/components/jobeffects-search/Study";
import SearchDetails from "@/components/jobeffects-search/SearchDetails";
import Search from "@/components/jobeffects-search/Search";
import EditStudy from "@/components/my-pages/EditStudy";
import StudySearch from "@/components/study-search/StudySearch";
import MyStudiesResearcher from "@/components/my-pages/MyStudiesResearcher";
import MyStudiesMember from "@/components/my-pages/MyStudiesMember";
import MyLibrary from "@/components/my-pages/MyLibrary";
import StudyOverview from "@/components/my-pages/StudyOverview";

Vue.use(Router);

const routeArr = {
    jobeffects: [
        {
            path: "/",
            name: "Search",
            component: Search
        },
        {
            path: "/Study/:id",
            name: "Study",
            component: Study
        },
        {
            path: "/SearchDetails",
            name: "SearchDetails",
            component: SearchDetails
        },
        {
            path: "/StudySearch",
            name: "StudySearch",
            component: StudySearch
        }
    ],
    studySearch: [
        {
            path: "/",
            name: "StudySearch",
            component: StudySearch
        },
        {
            path: "/Study/:id",
            name: "Study",
            component: Study
        }
    ],
    myPageApp: [
        {
            path: "/MyStudies",
            name: "MyStudiesMember",
            component: MyStudiesMember,
            beforeEnter: memberGuard()
        },
        {
            path: "/MyStudiesResearcher",
            name: "MyStudiesResearcher",
            component: MyStudiesResearcher,
            beforeEnter: researcherGuard()
        },
        {
            path: "/",
            name: "MyLibrary",
            component: MyLibrary
        },
        {
            path: "/Overview",
            name: "StudyOverview",
            component: StudyOverview,
            beforeEnter: researcherGuard()

        },
        {
            path: "/EditStudy",
            name: "EditStudy",
            component: EditStudy,
            beforeEnter: researcherGuard()
        },
        {
            path: "/CreateStudy",
            name: "CreateStudy",
            component: EditStudy,
            beforeEnter: researcherGuard()
        },
        {
            path: "/SuggestStudy",
            name: "SuggestStudy",
            component: EditStudy,
            beforeEnter: memberGuard()
        }
    ]
};

var routes = (function() {
    // there is a bug when trying to import several routers in main.js?
    if (document.getElementById("jobeffectsApp") !== null) {
        return routeArr.jobeffects;
    } else if (document.getElementById("studySearchApp") !== null) {
        return routeArr.studySearch;
    } else if (document.getElementById("myPageApp") !== null) {
        return routeArr.myPageApp;
    }
})();

function researcherGuard() {
    return (to, from, next) => {
        if (window.vm.role !== 'researcher') {
            console.warn("Navigation redirect")
            next('/');
        } else {
            next()
        }
    }
}

function memberGuard() {
    return (to, from, next) => {
        if (window.vm.role !== 'member') {
            console.warn("Navigation redirect")
            next('/MyStudiesResearcher');
        } else {
            next()
        }
    }
}

// router
const router = typeof routes !== "undefined" 
    ? new Router({ routes, scrollBehavior(to, from, savedPosition) 
        { 
            // savedPosition is only available for popstate navigations.
            if (savedPosition) return savedPosition

            // if the returned position is falsy or an empty object,
            // will retain current scroll position.
            if (to.params.savePosition) return {}

            // scroll to anchor by returning the selector
            if (to.hash) {
                let position = {selector: to.hash}

                // specify offset of the element
                // if (to.hash === '#anchor2') {
                //   position.offset = { y: 100 }
                // }
                return position
            }

            // scroll to top by default
            return {x: 0, y: 0}
        } 
    }) 
    : "";

// Tracking TODO: 
if (window.ga !== undefined && router !== "") {
    window.ga('set', 'page', router.currentRoute.path);
    window.ga('send', 'pageview');

    router.afterEach((to, from) => {
        window.ga('set', 'page', to.path);
        window.ga('send', 'pageview');
    });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js